import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "Kocaeli'ye gitmek için en iyi zaman hangisi?",
    a: "Kocaeli'yi ziyaret etmek için en ideal dönemler Nisan–Haziran ve Eylül–Kasım aylarıdır. İlkbaharda Kartepe'nin ormanları ve Sapanca Gölü çevresi yeşillenirken, kış aylarında (Aralık–Mart) Kartepe kayak merkezi aktif olur. Yaz aylarında Sapanca Gölü kıyıları ve İzmit Körfezi kıyıları kalabalık olabilir.",
  },
  {
    q: "Kocaeli'de mutlaka görülmesi gereken yerler hangileri?",
    a: "Kartepe Kayak Merkezi ve orman yürüyüş parkurları, Sapanca Gölü kıyıları, İzmit Körfezi manzarası, Seka Park (Türkiye'nin en büyük şehir parkı), Kandıra sahilleri, Gebze'deki Çoban Mustafa Paşa Külliyesi ve Hereke halı fabrikası Kocaeli'nin öne çıkan noktalarıdır.",
  },
  {
    q: "Kartepe'de kayak yapılabilir mi ve nasıl gidilir?",
    a: "Evet, Kartepe Türkiye'nin en erişilebilir kayak merkezlerinden biridir. İstanbul'a sadece 1,5 saat uzaklıktadır. Kayak sezonu genellikle Aralık–Mart ayları arasındadır. Teleferik ile zirveye çıkılabilir; kayak kiralama ve eğitim hizmetleri mevcuttur. Hafta sonları çok kalabalık olduğundan hafta içi tercih edilmesi önerilir.",
  },
  {
    q: "Kocaeli'ye İstanbul'dan nasıl gidilir?",
    a: "İstanbul'dan Kocaeli'ye TEM otoyolu üzerinden araçla yaklaşık 1–1,5 saat sürer. Otobüs seferleri İstanbul Büyük Otogarı'ndan düzenli olarak kalkar. Marmaray ve banliyö treni ile de İzmit'e ulaşmak mümkündür. Kartepe için İzmit'ten minibüs veya araç kiralama seçenekleri mevcuttur.",
  },
  {
    q: "Kocaeli'de doğa aktiviteleri nelerdir?",
    a: "Kocaeli'de yapılabilecek doğa aktiviteleri: Kartepe'de kayak ve snowboard (kış), Kartepe ormanlarında yürüyüş ve bisiklet turu (yaz), Sapanca Gölü'nde kano ve tekne turu, Kandıra sahillerinde yüzme ve sörf, Seka Park'ta bisiklet ve piknik. Bölge, İstanbul'a yakınlığı nedeniyle hafta sonu kaçamağı için idealdir.",
  },
  {
    q: "Seka Park nedir ve nerede?",
    a: "Seka Park, İzmit şehir merkezinde yer alan ve eski Seka kağıt fabrikasının arazisi üzerine kurulmuş Türkiye'nin en büyük şehir parklarından biridir. Bisiklet yolları, yürüyüş parkurları, çocuk oyun alanları, kafeler ve etkinlik alanlarıyla her yaştan ziyaretçiye hitap eder. Giriş ücretsizdir.",
  },
  {
    q: "Kocaeli'de ne yenilmeli?",
    a: "Kocaeli mutfağında öne çıkan lezzetler: İzmit pişmaniyesi (Türkiye'nin en ünlü pişmaniyesi), Hereke'de taze balık, Kandıra'da yöresel yoğurt ve peynirler, Sapanca çevresindeki restoranlarda göl balığı ve Kartepe'de dağ kahvaltısıdır. İzmit pişmaniyesi hediye olarak da çok tercih edilir.",
  },
  {
    q: "Hereke halısı nedir ve nereden alınabilir?",
    a: "Hereke halısı, Kocaeli'nin Hereke ilçesinde üretilen ve dünyaca ünlü el dokuma halılardır. 19. yüzyılda Osmanlı sarayları için üretilmeye başlanan bu halılar, ince işçilikleri ve dayanıklılıklarıyla bilinir. Hereke'deki fabrika ve atölyeleri ziyaret ederek üretim sürecini izleyebilir ve satın alabilirsiniz.",
  },
  {
    q: "Kandıra sahilleri nasıl?",
    a: "Kandıra, Kocaeli'nin Karadeniz kıyısındaki ilçesidir. Uzun ve temiz kumsalları, kamp alanları ve doğal güzellikleriyle özellikle yaz aylarında tercih edilir. Ağva ve Şile ile birlikte İstanbul çevresinin en güzel sahil destinasyonları arasında yer alır. Haziran–Eylül arası deniz sezonu için idealdir.",
  },
  {
    q: "Kocaeli'de kaç gün geçirmek gerekir?",
    a: "Kocaeli'nin öne çıkan noktalarını görmek için 2–3 gün yeterlidir. İlk gün Kartepe ve orman yürüyüşü, ikinci gün Sapanca Gölü ve Seka Park, üçüncü gün ise Kandıra sahili veya Hereke ziyareti için idealdir. Sakarya ile birleştirirseniz 4–5 günlük kapsamlı bir Marmara doğa turu yapabilirsiniz.",
  },
  {
    q: "Kocaeli'de konaklama seçenekleri nelerdir?",
    a: "Kocaeli'de konaklama için Kartepe'deki dağ otelleri ve bungalovlar, Sapanca Gölü kıyısındaki butik oteller, İzmit şehir merkezindeki zincir oteller ve Kandıra'daki kamp alanları tercih edilebilir. Kartepe'deki dağ otelleri özellikle kış sezonunda çok popülerdir; erken rezervasyon önerilir.",
  },
  {
    q: "Kocaeli'den günübirlik gezi yapılabilecek yerler var mı?",
    a: "Kocaeli'den günübirlik yapılabilecek en popüler destinasyonlar: Sakarya (Taraklı, Acarlar Longozu), Bolu (Abant Gölü, Yedigöller), İstanbul (1–1,5 saat), Bursa (2 saat) ve Adapazarı'dır. Kocaeli'nin merkezi konumu sayesinde Marmara Bölgesi'nin pek çok güzel noktasına kolayca ulaşılabilir.",
  },
];

const KocaeliFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const title = "Kocaeli Seyahat SSS — Kartepe, Sapanca ve Kandıra Rehberi 2026";
    const desc = "Kocaeli'ye seyahat planlayanlar için en sık sorulan sorular: Kartepe kayak, Sapanca Gölü, Kandıra sahilleri, İzmit pişmaniyesi ve ulaşım hakkında kapsamlı rehber.";
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
      el.textContent = JSON.stringify(data);
    };

    setCanonical("https://geziturkiyem.com/kocaeli-sss");
    setMeta("description", desc);
    setMeta("keywords", "kocaeli seyahat, kartepe kayak, sapanca gölü, kandıra sahil, kocaeli sss, izmit pişmaniyesi, seka park izmit, hereke halısı, kartepe teleferik, kocaeli doğa yürüyüşü, kartepe snowboard, kocaeli kış tatili, kandıra karadeniz sahili, kocaeli hafta sonu kaçamak, kocaeli istanbul yakını, kocaeli konaklama, kartepe bungalov, sapanca kano, kocaeli bisiklet, kocaeli ne zaman gidilir, kocaeli ulaşım, izmit otobüs, kocaeli tem otoyolu, marmara bölgesi rehberi, kocaeli günübirlik gezi, gebze çoban mustafa paşa, kocaeli yaz, kocaeli kış, kartepe kayak sezonu, kandıra kamp alanı");
    setMeta("geo.placename", "Kocaeli");
    setMeta("geo.region", "TR-41");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "article", true);
    setMeta("og:url", "https://geziturkiyem.com/kocaeli-sss", true);
    setMeta("og:image", "https://readdy.ai/api/search-image?query=Kartepe%20mountain%20Turkey%20snow%20covered%20forest%20ski%20resort%20winter%20landscape%20panoramic%20view&width=1200&height=630&seq=koc-sss-og&orientation=landscape", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);

    injectSchema("schema-kocaeli-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });

    injectSchema("schema-kocaeli-breadcrumb", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" },
        { "@type": "ListItem", "position": 2, "name": "Kocaeli SSS", "item": "https://geziturkiyem.com/kocaeli-sss" },
      ],
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
      document.getElementById("schema-kocaeli-faq")?.remove();
      document.getElementById("schema-kocaeli-breadcrumb")?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 pb-16 overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Kartepe%20mountain%20Turkey%20winter%20snow%20forest%20ski%20slopes%20cable%20car%20panoramic%20view%20Kocaeli&width=1400&height=500&seq=koc-sss-hero&orientation=landscape"
            alt="Kocaeli Kartepe"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-stone-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Kocaeli SSS</span>
          </nav>
          <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            Sık Sorulan Sorular
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Kocaeli Seyahat Rehberi
          </h1>
          <p className="text-stone-300 text-sm max-w-xl mx-auto">
            Kocaeli'ye seyahat planlayanların en çok merak ettiği sorular ve kapsamlı cevapları.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-14">
        {/* Intro */}
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-landscape-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-stone-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                Kocaeli Hakkında
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Marmara Bölgesi'nde yer alan Kocaeli, Kartepe'nin karlı yamaçları, Sapanca Gölü'nün berrak suları ve Kandıra'nın el değmemiş Karadeniz sahilleriyle İstanbul'a en yakın dört mevsim destinasyonlarından biridir. Aşağıda Kocaeli seyahati hakkında en sık sorulan soruları ve cevaplarını bulabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all duration-200 ${
                openIndex === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className={`font-semibold text-sm leading-snug pr-4 ${openIndex === i ? "text-amber-800" : "text-stone-900"}`}>
                  <a id={`sss-${i + 1}`} className="scroll-mt-20">{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-500 text-white rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Related Links */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Link to="/sakarya-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-water-flash-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Sakarya SSS</p>
            <p className="text-xs text-stone-400">Sapanca ve Taraklı rehberi</p>
          </Link>
          <Link to="/bolu-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-tree-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Bolu SSS</p>
            <p className="text-xs text-stone-400">Abant ve Yedigöller rehberi</p>
          </Link>
          <Link to="/istanbul-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-building-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">İstanbul SSS</p>
            <p className="text-xs text-stone-400">Boğaz ve tarihi yarımada rehberi</p>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default KocaeliFaq;
